export const adverbData = [
  { id: 1, korean: "즉시", english: "immediately" },
  { id: 2, korean: "신속하게", english: "promptly" },
  { id: 3, korean: "정기적으로", english: "regularly" },
  { id: 4, korean: "효과적으로", english: "effectively" },
  { id: 5, korean: "성공적으로", english: "successfully" },
  { id: 6, korean: "간단히", english: "briefly" },
  { id: 7, korean: "일반적으로", english: "generally" },
  { id: 8, korean: "급진적으로", english: "radically" },
  { id: 9, korean: "직접적으로", english: "directly" },
  { id: 10, korean: "깔끔하게", english: "neatly" },
  { id: 11, korean: "무겁게", english: "heavily" },
  { id: 12, korean: "빽빽하게", english: "densely" },
  { id: 13, korean: "고르게", english: "evenly" },
  { id: 14, korean: "깊이", english: "deeply" },
  { id: 15, korean: "반복적으로", english: "repeatedly" },
  { id: 16, korean: "반대로", english: "conversely" },
  { id: 17, korean: "이전에", english: "formerly" },
  { id: 18, korean: "거의 ~않게", english: "hardly" },
  { id: 19, korean: "자동적으로", english: "automatically" },
  { id: 20, korean: "상당히", english: "considerably" },
  { id: 21, korean: "조용히", english: "silently" },
  { id: 22, korean: "어색하게", english: "awkwardly" },
  { id: 23, korean: "단단히", english: "solidly" },
  { id: 24, korean: "날카롭게", english: "sharply" },
  { id: 25, korean: "널리", english: "widely" },
  { id: 26, korean: "성실하게", english: "diligently" },
  { id: 27, korean: "전적으로", english: "entirely" },
  { id: 28, korean: "물리적으로", english: "physically" },
  { id: 29, korean: "별도로", english: "separately" },
  { id: 30, korean: "흔히", english: "commonly" },
  { id: 31, korean: "사실상", english: "factually" },
  { id: 35, korean: "사적으로", english: "privately" },
  { id: 36, korean: "현저하게", english: "markedly" },
  { id: 37, korean: "호의적으로", english: "favorably" },
  { id: 38, korean: "알맞은 가격으로", english: "affordably" },
  { id: 39, korean: "꾸준히", english: "steadily" },
  { id: 40, korean: "잠시", english: "momentarily" },
  { id: 41, korean: "편리하게", english: "conveniently" },
  { id: 42, korean: "행복하게", english: "happily" },
  { id: 43, korean: "우연히", english: "accidentally" },
  { id: 44, korean: "적절하게", english: "properly" },
  { id: 45, korean: "적당히", english: "moderately" },
  { id: 46, korean: "좁게", english: "narrowly" },
  { id: 47, korean: "상대적으로", english: "relatively" },
  { id: 48, korean: "도덕적으로", english: "morally" },
  { id: 49, korean: "그에 따라", english: "accordingly" },
  { id: 50, korean: "열심히", english: "eagerly" },
  { id: 51, korean: "매력적으로", english: "invitingly" },
  { id: 52, korean: "결국", english: "ultimately" },
  { id: 53, korean: "일상적으로", english: "routinely" },
  { id: 54, korean: "자신감 있게", english: "confidently" },
  { id: 55, korean: "도움이 되게", english: "helpfully" },
  { id: 56, korean: "주로", english: "chiefly" },
  { id: 57, korean: "독점적으로", english: "exclusively" },
  { id: 58, korean: "능숙하게", english: "capably" },
  { id: 59, korean: "확실히", english: "assuredly" },
  { id: 60, korean: "철저히", english: "thoroughly" },
  { id: 61, korean: "명백하게", english: "evidently" },
  { id: 62, korean: "수월하게", english: "effortlessly" },
  { id: 63, korean: "부분적으로", english: "partially" },
  { id: 64, korean: "추상적으로", english: "abstractly" },
  { id: 65, korean: "본능적으로", english: "instinctively" },
  { id: 66, korean: "책임감 있게", english: "responsibly" },
  { id: 67, korean: "계절적으로", english: "seasonally" },
  { id: 68, korean: "단호하게", english: "assertively" },
  { id: 69, korean: "통계적으로", english: "statistically" },
  { id: 70, korean: "정확하게", english: "accurately" },
  { id: 71, korean: "의도적으로", english: "intentionally" },
  { id: 72, korean: "자발적으로", english: "voluntarily" },
  { id: 73, korean: "생산적으로", english: "productively" },
  { id: 74, korean: "기밀로", english: "confidentially" },
  { id: 75, korean: "만장일치로", english: "unanimously" },
  { id: 76, korean: "개별적으로", english: "individually" },
  { id: 77, korean: "확실히", english: "certainly" },
  { id: 78, korean: "상호간에", english: "mutually" },
  { id: 79, korean: "무심코", english: "inadvertently" },
  { id: 80, korean: "헤아릴 수 없이", english: "immeasurably" },
  { id: 81, korean: "창의적으로", english: "creatively" },
  { id: 82, korean: "매력적으로", english: "attractively" },
  { id: 83, korean: "겨우", english: "barely" },
  { id: 84, korean: "공정하게", english: "fairly" },
  { id: 85, korean: "불리하게", english: "adversely" },
  { id: 86, korean: "인상적으로", english: "impressively" },
  { id: 87, korean: "동일하게", english: "identically" },
  { id: 88, korean: "독특하게", english: "distinctively" },
  { id: 89, korean: "의심스럽게", english: "suspiciously" },
  { id: 90, korean: "충분히", english: "sufficiently" },
  { id: 91, korean: "형성적으로", english: "formatively" },
  { id: 92, korean: "본질적으로", english: "inherently" },
  { id: 93, korean: "현저하게", english: "remarkably" },
  { id: 94, korean: "간헐적으로", english: "intermittently" },
  { id: 95, korean: "대략", english: "approximately" },
  { id: 96, korean: "대담하게", english: "boldly" },
  { id: 97, korean: "격렬하게", english: "violently" },
  { id: 98, korean: "즉각적으로", english: "instantly" },
  { id: 99, korean: "협력적으로", english: "cooperatively" },
  { id: 100, korean: "배려하여", english: "considerately" },
  { id: 101, korean: "흥미롭게", english: "interestingly" },
  { id: 102, korean: "구조적으로", english: "structurally" },
  { id: 103, korean: "강렬하게", english: "intensely" },
  { id: 104, korean: "열정적으로", english: "enthusiastically" },
  { id: 105, korean: "즉", english: "namely" },
  { id: 106, korean: "간결하게", english: "concisely" },
  { id: 107, korean: "기억에 남게", english: "memorably" },
  { id: 108, korean: "도전적으로", english: "challengingly" },
  { id: 109, korean: "정교하게", english: "elaborately" },
  { id: 110, korean: "전문적으로", english: "expertly" },
  { id: 111, korean: "눈에 띄게", english: "noticeably" },
  { id: 112, korean: "대충", english: "roughly" },
  { id: 113, korean: "동등하게", english: "equally" },
  { id: 114, korean: "연속적으로", english: "consecutively" },
  { id: 115, korean: "공개적으로", english: "openly" },
  { id: 116, korean: "점진적으로", english: "progressively" },
  { id: 117, korean: "비교적으로", english: "comparably" },
  { id: 118, korean: "잠재적으로", english: "potentially" },
  { id: 119, korean: "불충분하게", english: "insufficiently" },
  { id: 120, korean: "알면서도", english: "knowingly" },
  { id: 121, korean: "서둘러", english: "hastily" },
  { id: 122, korean: "습관적으로", english: "habitually" },
  { id: 123, korean: "광범위하게", english: "extensively" },
  { id: 124, korean: "대립하여", english: "opposingly" },
  { id: 125, korean: "대부분", english: "mostly" },
  { id: 126, korean: "느슨하게", english: "loosely" },
  { id: 127, korean: "비극적으로", english: "tragically" },
  { id: 128, korean: "기대에 차서", english: "expectantly" },
  { id: 129, korean: "멀리", english: "distantly" },
];
